import { render, staticRenderFns } from "./ConfirmCollege.vue?vue&type=template&id=4347f3b9&scoped=true&"
import script from "./ConfirmCollege.vue?vue&type=script&lang=js&"
export * from "./ConfirmCollege.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmCollege.vue?vue&type=style&index=0&id=4347f3b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347f3b9",
  null
  
)

export default component.exports